/** @format */

import { Axios } from "./httpService";

export const loginService = (data) => {
  return Axios.post("/User/Login", data);
};

export const logoutService = () => {
  return Axios.get("/User/LogOut");
};

export const getUserService = () => {
  return Axios.get("/User/CheckLogin");
};
